import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div style={s.page}>
      <div style={s.content}>
        <p style={s.eyebrow}>404</p>
        <h1 style={s.title}>This page doesn't exist.</h1>
        <p style={s.sub}>
          The piece might have been deleted, the link might be wrong, or you might have wandered somewhere the map doesn't cover.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="btn btn-ink">← Home</Link>
          <Link to="/feed" className="btn btn-ghost">The Feed</Link>
        </div>
      </div>
    </div>
  )
}

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', background: 'var(--paper)' },
  content: { textAlign: 'center', maxWidth: 480 },
  eyebrow: { fontFamily: "'DM Mono', monospace", fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '1rem' },
  title: { fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: '1rem' },
  sub: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '1rem', color: 'var(--muted)', lineHeight: 1.7, marginBottom: '2rem' },
}
